import { Theme, useMediaQuery } from '@mui/material';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';

import { CoreBox, CoreTypography } from '@youscience/core';

import { Breadcrumb } from '@interfaces';

import ChevronLeftIcon from '@images/chevron-left.svg?react';
import ChevronRightIcon from '@images/chevron-right.svg?react';

import BreadcrumbLink from './BreadcrumbLink';
import { sxStyles } from './Breadcrumbs.styles';

interface BreadcrumbsProps {
  links: Breadcrumb[];
  currentPage?: string;
}

export const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { links, currentPage = '' } = props;
  const isMobileScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const mobileBreadcrumbs = links[links.length - 1];

  return isMobileScreen ? (
    <CoreBox sx={sxStyles.mobileBreadcrumbs}>
      <BreadcrumbLink {...mobileBreadcrumbs} to={mobileBreadcrumbs.to}>
        <ChevronLeftIcon />

        {mobileBreadcrumbs.text}
      </BreadcrumbLink>
    </CoreBox>
  ) : (
    <MuiBreadcrumbs aria-label="breadcrumb" separator={<ChevronRightIcon />} sx={sxStyles.breadcrumbs}>
      {links.map((link) => (
        <BreadcrumbLink {...link} key={link.to}>
          {link.text}
        </BreadcrumbLink>
      ))}

      <CoreTypography color="text.secondary">{currentPage}</CoreTypography>
    </MuiBreadcrumbs>
  );
};
